import { IconButton } from "@mui/material"
import React from "react"
// import CancelIcon from "@mui/icons-material/Cancel"
export default function CloseButton({ onClick, sx, disabled = false }) {
  return (
    <IconButton
      sx={[{ p: 0 }, sx]}
      onClick={onClick}
      disabled={disabled}
      className="closeBtn"
    >
      {/* <CancelIcon color="danger" sx={{ fontSize: 40 }} className="closeBtn" /> */}
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-colorDanger MuiSvgIcon-fontSizeMedium closeBtn css-1sijne5-MuiSvgIcon-root"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        style={{
          width: 40,
          height: 40,
          fontSize: 40,
          color: disabled ? "gray" : "#d32f2f",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        data-testid="CancelIcon"
      >
        <path
          style={{
            fill: disabled ? "gray" : "#d32f2f",
          }}
          className="closeBtn"
          d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
        ></path>
      </svg>
    </IconButton>
  )
}
